import { Card, Space } from '@sravni/react-design-system';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';

import type { GatewayRanking } from 'commonTypes/api/gatewayRanking';

import styles from './TopX.module.scss';
import { TOPX_TEXTS } from './TopX.texts';

type TopXProps = {
  allOffers: GatewayRanking.TRankingOffer[];
  firstName: string;
  isAllOffersWithStatus: boolean;
  applySelectedOffersButton: JSX.Element;
  topXBanksDropdown: JSX.Element;
};
export const TopXCommonGrid: FC<TopXProps> = ({
  firstName,
  isAllOffersWithStatus,
  applySelectedOffersButton,
  topXBanksDropdown,
}) => {
  const isMobile = useIsMobile();

  return (
    <Card className={styles.topXCard}>
      <Space
        direction="vertical"
        size={16}
      >
        <Heading level={4}>
          {firstName}, {TOPX_TEXTS.TITLE}
        </Heading>
        <Space
          size={8}
          direction={isMobile ? 'vertical' : 'horizontal'}
        >
          {topXBanksDropdown}
          <Card
            className={cn('h-color-D60 h-pt-12 h-pb-12 h-pl-16 h-pr-16 h-br-12', styles.sendRequestsBlock)}
            color="dark"
          >
            {isAllOffersWithStatus ? (
              <Space
                align="center"
                justify={isMobile ? 'center' : 'flex-start'}
              >
                <Text size={12}>{TOPX_TEXTS.ALL_SENT}</Text>
              </Space>
            ) : (
              applySelectedOffersButton
            )}
          </Card>
        </Space>
      </Space>
    </Card>
  );
};
